import {
	IonButton,
	IonButtons,
	IonContent,
	IonFooter,
	IonHeader,
	IonIcon,
	IonPage,
	IonTitle,
	IonToolbar,
} from "@ionic/react";
import { useHistory } from "react-router";

import { arrowBack } from "ionicons/icons";

import { LanguageSwitcher } from "../../components/language-switcher";
// import { PlantSwitcher } from "../../components/plant-switcher";
import { ThemeSwitcher } from "../../components/theme-switcher";
import { UserDocumentation } from "../../components/user-documentation";
import { useTranslation } from 'react-i18next';

export function SettingsPage() {
	const history = useHistory();
	const { t } = useTranslation();

	function onBack() {
		history.push("/landing");
	}

	return (
		<IonPage>
			<IonHeader>
				<IonToolbar>
					<IonButtons slot="start">
						<IonButton shape="round" onClick={onBack}>
							<IonIcon icon={arrowBack}></IonIcon>
						</IonButton>
					</IonButtons>
					<IonTitle>{t("userSettings.title")}</IonTitle>
				</IonToolbar>
			</IonHeader>
			<IonContent>
				<ThemeSwitcher />
				<LanguageSwitcher />
				{/* <PlantSwitcher /> */}
			</IonContent>
			<IonFooter>
				<UserDocumentation />
			</IonFooter>
		</IonPage>
	);
}

export default SettingsPage;
